import { lazy } from 'react';
/**
 * By default all routes are protected and have 'default' layout.
 * If a route doesn't requires auth, provide public: true
 * If a route requires blank layout, provide layout: 'blank'
 */
export const pageRoutes = [
  {
    path: '/login',
    component: lazy(() => import('../views/authentication/Login')),
    public: true,
    layout: 'blank',
  },
  {
    path: '/projects',
    role: 'Customer',
    component: lazy(() => import('../views/projects/ProjectList')),
  },
  {
    path: '/services',
    role: 'Sustainability Architect',
    component: lazy(() => import('../views/services/ServiceList')),
  },
  {
    path: '/services/:serviceId',
    role: 'Sustainability Architect',
    component: lazy(() => import('../views/services/Service')),
  },
  {
    path: '/projects/:projectId',
    role: 'Customer',
    component: lazy(() => import('../views/projects/Project')),
  },
  {
    path: '/reports',
    role: 'Customer',
    component: lazy(() => import('../views/reports/ReportList')),
  },
  {
    path: '/reports/:reportId',
    role: 'Customer',
    component: lazy(() => import('../views/reports/Report')),
  },
  {
    path: '/carbon-coefficient',
    role: 'Sustainability Architect',
    component: lazy(() => import('../views/carbon_coefficient/CarbonCoefficientList')),
  },
  {
    path: '/formulae/',
    role: 'Sustainability Architect',
    component: lazy(() => import('../views/formulae/FormulaList')),
  },
  {
    path: '/formulae/:formAction',
    role: 'Sustainability Architect',
    component: lazy(() => import('../views/formulae/FormulaForm')),
  },
  {
    path: '/tags/',
    role: 'Sustainability Architect',
    component: lazy(() => import('../views/tags/TagsList')),
  },
  {
    path: '/governance/',
    role: 'Customer',
    component: lazy(() => import('../views/governance/Governance')),
  },
  {
    path: '/social/',
    role: 'Customer',
    component: lazy(() => import('../views/social/Social')),
  },
];
